import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "../style/AddSensorModal.css";

export default function AddSensorModal({ open, onClose, onAdd }) {
    const [nombre, setNombre] = useState("");
    const [tipo, setTipo] = useState("temperatura");
    const [terreno, setTerreno] = useState("");
    const [valorMin, setValorMin] = useState("");
    const [valorMax, setValorMax] = useState("");
    const [terrenos, setTerrenos] = useState([]);
    const [mensaje, setMensaje] = useState({ tipo: "", texto: "" });

    const limpiarFormulario = () => {
        setNombre("");
        setTipo("temperatura");
        setTerreno("");
        setValorMin("");
        setValorMax("");
    };

    useEffect(() => {
        if (open) {
            const fetchTerrenos = async () => {
                try {
                    const token = localStorage.getItem("token");
                    const res = await fetch("https://agro-nexus-prod.vercel.app/api/terrenos", {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    const data = await res.json();
                    if (res.ok && data.success) {
                        setTerrenos(data.terrenos);
                    } else {
                        setTerrenos([]);
                    }
                } catch (err) {
                    setTerrenos([]);
                }
            };
            fetchTerrenos();
        } else {
            limpiarFormulario();
            setMensaje({ tipo: "", texto: "" });
        }
    }, [open]);

    useEffect(() => {
        if (mensaje.texto) {
            const timer = setTimeout(() => {
                setMensaje({ tipo: "", texto: "" });
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [mensaje]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje({ tipo: "", texto: "" });
        try {
            const token = localStorage.getItem("token");
            const res = await fetch("https://agro-nexus-prod.vercel.app/api/sensores", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    nombre,
                    tipo_sensor: tipo,
                    terreno_id: terreno,
                    valor_minimo: valorMin || null,
                    valor_maximo: valorMax || null,
                }),
            });

            const data = await res.json();
            if (res.ok && data.success) {
                setMensaje({ tipo: "exito", texto: "✅ Sensor agregado correctamente" });
                onAdd();
                limpiarFormulario();
                setTimeout(() => {
                    onClose();
                }, 1500);
            } else {
                setMensaje({ tipo: "error", texto: `⚠️ ${data.message}` });
            }
        } catch (err) {
            setMensaje({ tipo: "error", texto: "❌ Error al crear el sensor" });
        }
    };

    if (!open) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <div className="modal-header">
                    <h2>Nuevo Sensor</h2>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                {mensaje.texto && (
                    <div className={`mensaje ${mensaje.tipo}`}>{mensaje.texto}</div>
                )}

                <form onSubmit={handleSubmit} className="modal-form">
                    <input
                        type="text"
                        placeholder="Nombre del sensor"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        required
                    />

                    <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
                        <option value="temperatura">Temperatura</option>
                        <option value="humedad">Humedad</option>
                        <option value="luz">Luz</option>
                        <option value="ph">pH</option>
                    </select>

                    <select
                        value={terreno}
                        onChange={(e) => setTerreno(e.target.value)}
                        required
                    >
                        <option value="">Selecciona un terreno</option>
                        {terrenos.map((t) => (
                            <option key={t.id} value={t.id}>
                                {t.nombre}
                            </option>
                        ))}
                    </select>

                    <input
                        type="number"
                        placeholder="Valor mínimo"
                        value={valorMin}
                        onChange={(e) => setValorMin(e.target.value)}
                    />

                    <input
                        type="number"
                        placeholder="Valor máximo"
                        value={valorMax}
                        onChange={(e) => setValorMax(e.target.value)}
                    />

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-cancel">
                            Cancelar
                        </button>
                        <button type="submit" className="btn-primary">
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
